import { useQuery } from '@tanstack/react-query'
import { FlowView, OrganisationRead, OrganisationsService } from 'Service'
import { useEffect, useMemo, useState } from 'react'

/**
 * Utility hook to fetch experience center details
 * @returns
 */
export const useExperienceCenter = () => {
  // const [productTourLink, setProductTourLink] = useState('#')
  // const [demoClient, setdemoClient] = useState<{ uuid: string } | null>(null)
  // const [demoFlow, setdemoFlow] = useState<{ uuid: string } | null>(null)

  const { data: demoClient, isPending: fetchingDemoClient } = useQuery({
    queryKey: ['OrganisationsService.organisationsDemoClientUuidRetrieve'],
    queryFn: OrganisationsService.organisationsDemoClientUuidRetrieve,
  })
  const { data: demoFlow } = useQuery({
    queryKey: ['OrganisationsService.organisationsDemoFlowUuidRetrieve'],
    queryFn: OrganisationsService.organisationsDemoFlowUuidRetrieve,
  })

  const productTourLink = useMemo(() => {
    return `/clients/${demoClient?.uuid}/voice-agents/`
  }, [demoClient, demoFlow])

  return { demoClient, fetchingDemoClient, demoFlow, productTourLink }
}
